import { captureConsoleIntegration, getGlobalScope, init } from '@sentry/react'
import { app_version, development, production, staging } from 'app/config/constants'

const DSN = 'https://88589a4ff223c5c8a4c6114e996e0ae8@o4507930409959424.ingest.de.sentry.io/4508376130060368'
const DSN_DEVELOPMENT = 'https://2710405ae3b1559ddefeca87d7f57e98@o4507930409959424.ingest.de.sentry.io/4508020335050832'
const dsn = development ? DSN_DEVELOPMENT : DSN
const environment = production ? 'production' : staging ? 'staging' : development ? 'development' : 'unknown'

export function sentry() {
  if (development) return
  init({
    dsn,
    environment,
    release: app_version,
    integrations: [
      captureConsoleIntegration({ levels: ['error'] }),
    ],
    attachStacktrace: true,
  })
  if (development) getGlobalScope().setTag('application', 'share-client')
}
